const Footer = () => {
    return (
        <footer>
            <p className="bye-message">Happy Coding</p>
            <p>&copy; {new Date().getFullYear()} Emmanuel Erogo.All Rights reserved.</p>
        </footer>
    );
};
export default Footer;